import type { HTMLAttributes } from 'react';

import { cn } from '@shared/lib/cn';

export type BadgeSkeletonProps = Omit<HTMLAttributes<HTMLSpanElement>, 'children'>;

/** Badge 의 status=init. Figma 는 한 가지(64×24, 가운데 48×20 알약)다 */
export function BadgeSkeleton({ className, ...rest }: BadgeSkeletonProps) {
  return (
    <span
      aria-hidden="true"
      data-status="init"
      {...rest}
      className={cn(
        'skeleton-pulse',
        'inline-flex shrink-0 border-y-2 border-transparent px-2',
        className,
      )}
    >
      <span className="h-5 w-12 rounded-full bg-bg-pressed" />
    </span>
  );
}
